const hasValue = (value) => {
  if (value === undefined || value === null) return false
  if (typeof value === "string") {
    return value.trim() !== ""
  }
  return true
}

const getLanguageValues = (source) => {
  if (!source) return {}
  const english =
    hasValue(source.languageEnglish) && source.languageEnglish
      ? source.languageEnglish
      : source.languageProficiency?.english
  const turkish =
    hasValue(source.languageTurkish) && source.languageTurkish
      ? source.languageTurkish
      : source.languageProficiency?.turkish

  return { english, turkish }
}

/**
 * Eksik öğrenci alanlarını bulur.
 * @param {Object} studentData - Öğrenci bilgileri (API veya form datası)
 * @returns {string[]} Eksik alanların etiketleri
 */
export const getMissingStudentFields = (studentData = {}) => {
  const missing = []

  if (!hasValue(studentData.passportFile)) {
    missing.push("STUDENT_VALIDATION_PASSPORT")
  }

  if (!hasValue(studentData.highschoolTranscript)) {
    missing.push("STUDENT_VALIDATION_TRANSCRIPT")
  }

  if (!hasValue(studentData.highschoolDiploma)) {
    missing.push("STUDENT_VALIDATION_DIPLOMA")
  }

  const identityFields = ["dateOfBirth", "nationality", "city", "country"]
  const hasAllIdentity = identityFields.every((field) => hasValue(studentData[field]))
  if (!hasAllIdentity) {
    missing.push("STUDENT_VALIDATION_IDENTITY")
  }

  return missing
}

